// extracted by mini-css-extract-plugin
module.exports = {"Wrap":"index_Wrap_1ZJ3G","value":"index_value_YpGvG","image":"index_image_2aIzQ","mode":"index_mode_1iU1L"};